<template>
  <div class="view pa24">
    <div class="d-flex">
      <el-row :gutter="24">
        <el-col :xl="24" :lg="16" class="d-flex justify-content-between w100p">
          <div class="d-flex align-items-center">
            <el-input v-model="name" class="mb10" style="width: 240px" placeholder="请输入产品类别名称" clearable />
            <el-button class="ml10 mb10" type="primary" @click="getCustomer">搜索</el-button>
            <el-button class="ml10 mb10" type="primary" @click="handleAddPageClass('add')"
              v-if="storeStatus==0">+添加BOM结构</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-table :data="tableData" style="width: 100%;margin-bottom: 20px;" row-key="id" border lazy :load="load"
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
      <el-table-column prop="name" align="center" label="名称" />
      <el-table-column prop="fitNum" align="center" label="组配所需数量" />
      <el-table-column prop="specName" align="center" label="规格">
        <template slot-scope="scope">
          {{ scope.row.specName || '--' }}
        </template>
      </el-table-column>
      <el-table-column prop="partNumber" align="center" label="件号">
        <template slot-scope="scope">
          {{ scope.row.partNumber || '--' }}
        </template>
      </el-table-column>
      <el-table-column prop="modelNo" align="center" label="型号">
        <template slot-scope="scope">
          {{ scope.row.modelNo || '--' }}
        </template>
      </el-table-column>
      <el-table-column prop="inventCode" align="center" label="库存编码">
        <template slot-scope="scope">
          {{ scope.row.inventCode || '--' }}
        </template>
      </el-table-column>
      <!--      <el-table-column-->
      <!--          prop="stockNum"-->
      <!--          align="center"-->
      <!--          label="库存数"-->
      <!--      >-->
      <!--        <template slot-scope="scope">-->
      <!--          {{ getStockNum(scope.row,0) }}-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <el-table-column prop="stockWarningNum" align="center" label="库存预警数">
        <template slot-scope="scope">
          <span class="text-danger">{{ scope.row.stockWarningNum || '--' }}</span>
        </template>
      </el-table-column>
      <!--      <el-table-column-->
      <!--          prop="needSpare"-->
      <!--          align="center"-->
      <!--          label="是否备件"-->
      <!--      >-->
      <!--        <template slot-scope="scope">-->
      <!--          {{ scope.row.needSpare?'是':'否'}}-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <!--      <el-table-column-->
      <!--          prop="isRemindScm"-->
      <!--          align="center"-->
      <!--          label="是否提醒SCM系统"-->
      <!--      >-->
      <!--        <template slot-scope="scope">-->
      <!--          {{ scope.row.isRemindScm?'是':'否'}}-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <!--      <el-table-column-->
      <!--          prop="isRemindAps"-->
      <!--          align="center"-->
      <!--          label="是否提醒APS系统"-->
      <!--      >-->
      <!--        <template slot-scope="scope">-->
      <!--          {{ scope.row.isRemindAps?'是':'否'}}-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <!--      <el-table-column-->
      <!--          prop="isNeedOutsourcing"-->
      <!--          align="center"-->
      <!--          label="是否需要委外检测"-->
      <!--      >-->
      <!--        <template slot-scope="scope">-->
      <!--          {{ scope.row.isNeedOutsourcing?'是':'否'}}-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <el-table-column prop="sort" align="center" label="排序">
      </el-table-column>
      <el-table-column align="center" width="200" label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="editCustomer(scope.row)"
            v-if="storeStatus==0&& !scope.row.isProduct">编辑</el-button>
          <el-popconfirm confirm-button-text="确定" cancel-button-text="取消" @confirm="delPageClass(scope.row)"
            icon="el-icon-info" icon-color="red" title="确定要删除吗？">
            <el-button slot="reference" class="ml10" style="color: #fd634e" type="text"
              v-if="storeStatus==0 && !scope.row.isProduct">删除</el-button>
          </el-popconfirm>
          <el-button type="text" @click="setHierarchy(scope.row)" v-if="scope.row.isProduct">设置校验层级</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pageBox">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="currentPage" :page-sizes="[10, 15, 20]" layout="total, sizes, prev, pager, next, jumper" class=""
        :total="total" :pager-count="5" />
    </div>
    <SetHierarchy ref="setHierarchy" @getList="getList"></SetHierarchy>
    <AddPageClassDialog ref="addPageClassDialog" @getList="getList"></AddPageClassDialog>
  </div>
</template>

<script>
  import AddPageClassDialog from './component/AddPageClassDialog'
  import { deleteStoreClass } from '@/api/customPageClass'
  import { selectStoreClassList } from '@/api/storeClass.js'
  import { checkPermission } from "@/directives/permission";
  import SetHierarchy from "./component/setHierarchy.vue";
  export default {
    components: {
      AddPageClassDialog,
      SetHierarchy,
    },
    props: {
      classType: {
        default: 0
      },
      storeStatus: {
        default: '0'
      }
    },
    data() {
      return {
        name: null,
        tableData: [],
        pageSize: 10,
        pageNum: 1,
        total: 0,
        currentPage: 1,
        status: '',
        typeList: [
          { value: 0, label: '钢板' },
          { value: 1, label: '卷材' }
        ],
        parentId: ''
      };
    },
    created() {
      this.getList()
    },
    methods: {
      checkPermission,
      load(tree, treeNode, resolve) {
        setTimeout(() => {
          let params = {
            noPage: true,
            type: this.classType,
            name: this.name,
            classType: 0,
            status: this.storeStatus,
            parentId: tree.id
          }
          selectStoreClassList(params).then(res => {
            resolve(res.data.list)
          })
        }, 1000)
      },
      setHierarchy(row) {
        //设置校验查询层级
        this.$refs.setHierarchy.openDialog(row)
      },
      printClass(row, type) {
        if (1 == type) {
          //单个
          this.$refs.classPrint.init([row])
        } else if (2 == type) {
          //打印子级
          if (!row.hasChildren) {
            this.$message.error('该类别下没有子级')
            return;
          } else {
            if (!row.children || row.children.length <= 0) {
              let params = {
                noPage: true,
                type: this.classType,
                classType: 0,
                parentId: row.id
              }
              pageClassList(params).then(res => {
                if (res.data.list) {
                  this.$refs.classPrint.init(res.data.list)
                }
              })
            }
          }
        }
      },
      getStockNum(row, num) {
        num += row.stockNum
        if (row.children && row.children.length > 0) {
          row.children.forEach(item => {
            num += item.stockNum;
            this.getStockNum(item, num)
          })
        }
        return num;
      },
      show(row) {
        this.$refs.addPageClassDialog.openDialog('show', row, this.classType)
      },
      getCustomer() {
        this.getList()
      },
      handleSizeChange(num) {
        this.pageSize = num;
        this.pageNum = 1;
        this.getList();
      },
      handleCurrentChange(num) {
        this.pageNum = num;
        this.getList();
      },
      handleAddPageClass(type, id) {
        this.$refs.addPageClassDialog.openDialog(type, id, this.classType)
      },
      getList() {
        let params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          parentId: this.parentId
        }
        this.tableData = []
        selectStoreClassList(params).then(res => {
          this.tableData = res.data.list
          this.total = res.data.total
        })
      },
      editCustomer(data) {
        this.$refs.addPageClassDialog.openDialog('edit', data, this.classType)
      },
      delPageClass(data) {
        deleteStoreClass(data.id).then(res => {
          if (res.code === 200) {
            this.$message({
              type: "success",
              message: "操作成功",
            });
            this.getList()
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
      },
      lookImg(row) {
        this.$router.push({
          path: '/classImgList', query: {
            id: row.id,
            name: row.name,
          },
        })
      }
    },

  }
</script>

<style lang="scss" scoped>
  .ml10 {
    margin-left: 10px;
  }

  .pageBox {
    display: flex;
    justify-content: flex-end;
  }
</style>